// removed by extract-text-webpack-plugin
module.exports = {"psm-title":"GroupTitleExample__psm-title","psmTitle":"GroupTitleExample__psm-title"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/GroupTitleExample/GroupTitleExample.css
// module id = 1250
// module chunks = 8